import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faVideo } from "@fortawesome/free-solid-svg-icons";
import { faImage } from "@fortawesome/free-solid-svg-icons";

const box = {
  background: "#FFFFFF 0% 0% no-repeat padding-box",
  boxShadow: "0px 3px 6px #0000000A",
  border: "1px solid #DFDFDF",
  borderRadius: "30px",
  opacity: "1",
  padding: "1.75rem",
  minWidth: "31.9375rem",
  margin: "0px !important",
};

const lbl = {
  textAlign: "left",
  font: "normal normal 600 18px/27px Poppins",
  letterSpacing: "0px",
  color: "#646464",
  opacity: "1",
  fontSize: "18px",
  marginBottom: "1.5rem",
};

const textArea = {
  background: "#FFFFFF 0% 0% no-repeat padding-box",
  border: "1px solid #D5D5D5",
  borderRadius: "15px",
  opacity: "1",
};

const btn = {
  background:
    "transparent linear-gradient(196deg, #9100FF 0%, #4B00FF 100%) 0% 0% no-repeat padding-box",
  boxShadow: "0px 10px 20px #6A00FF73",
  borderRadius: "27px",
  opacity: "1",
  color: "#FFFFFF",
  padding: "8px",
  width: "7em",
  borderWidth: "thin",
};

const lblIco = {
  textAlign: "left",
  font: "normal 14px Poppins",
  letterSpacing: "0px",
  color: "#646464",
  opacity: "1",
};

const CrearPublicaciones = () => {
  return (
    <form style={box}>
      <div className="form-group">
        <label style={lbl}>Comparte una publicacion</label>
        <textarea
          className="form-control"
          rows="2"
          style={textArea}
          placeholder="Iniciar una publicacion"
        ></textarea>
      </div>
      <div className="form-inline">
        <label style={lblIco}>
          <FontAwesomeIcon icon={faImage} style={{ color: "#7821A0" }} />
          <span className="ml-2">Foto</span>
        </label>
        <label style={lblIco} className="ml-3">
          <FontAwesomeIcon icon={faVideo} style={{ color: "#7821A0" }} />
          <span className="ml-2">Video</span>
        </label>
        <label style={lblIco} className="ml-3">
          <FontAwesomeIcon icon={faUser} style={{ color: "#7821A0" }} />
          <span className="ml-2">Comparte un perfil</span>
        </label>
        <label style={lblIco} className="ml-3">
          <FontAwesomeIcon icon={faSearch} style={{ color: "#7821A0" }} />
          <span className="ml-2">Busca a un experto</span>
        </label>
        <button style={btn}>Publicar</button>
      </div>
    </form>
  );
};
export default CrearPublicaciones;
